import AddIcon from '@mui/icons-material/Add';
import { Grid, Box, Tooltip, IconButton } from '@mui/material';
import { isEmpty } from 'lodash';
import { MdOutlineInfo } from 'react-icons/md';
import { useNavigate } from 'react-router-dom';
import { ClientDTO } from 'wisestep-api';
import {
  EmptyTeamsAndUsersIcon,
  WsButton,
  WsTypoColors,
  WsTypoVariants,
  WsTypography,
} from 'wisestep-base';

import NoDataFoundCard from '../../../components/noDataFoundCard/NoDataFoundCard';
import { useWorkspaceContext } from '../../../context/WorkspaceContext/WorkspaceContext';
import ClientList from '../../../features/clientListingPage/components/ClientList';
import { ClientAction, useClientAuthz } from '../../../hooks/useClientAuthz';
import { clientsAmplitudeEvents } from '../helper/clientDetailsHelper';

interface IChildClientProps {
  clientId: string;
  parentName: string;
  childClients: ClientDTO[];
  totalChildCount: number;
}

const ChildClientsTab = ({
  clientId,
  parentName,
  childClients,
  totalChildCount,
}: IChildClientProps) => {
  const navigate = useNavigate();
  const workspace = useWorkspaceContext();
  const navigateToAddClient = () => {
    clientsAmplitudeEvents(
      'client_details_child_client_add',
      'Client Details Child Client Add',
      workspace
    );
    navigate(`/clients/${clientId}/add?isChild=false&parentName=${parentName}`);
  };

  const isAuthorizedAddClientDetails = useClientAuthz(ClientAction.ADD_CLIENT_DETAILS);
  const GetAddChildEntitiesButton = () => (
    <WsButton startIcon={<AddIcon fontSize="small" />} onClick={navigateToAddClient}>
      Add Child Client
    </WsButton>
  );

  return (
    <>
      <Grid
        item
        container
        xs={12}
        justifyContent={workspace.owns ? 'flex-end' : 'space-between'}
        alignItems="center"
      >
        {!workspace.owns && childClients.length > 0 && (
          <Grid item container alignItems="center" xs={6}>
            <WsTypography variant={WsTypoVariants.SUB_TITLE} color={WsTypoColors.BLACK}>
              Showing to {childClients.length} of {totalChildCount} child clients
            </WsTypography>
            <Tooltip title="Child Clients access granted by workspace admin or client owner">
              <IconButton onClick={() => {}}>
                <MdOutlineInfo size={20} />
              </IconButton>
            </Tooltip>
          </Grid>
        )}
        <Grid item container xs={6} justifyContent="flex-end">
          {!isEmpty(childClients) && isAuthorizedAddClientDetails && <GetAddChildEntitiesButton />}
        </Grid>
      </Grid>

      <Grid sx={{ width: '100%' }}>
        {childClients && childClients.length > 0 ? (
          <ClientList
            requireHeaderBanner={false}
            isChild={false}
            parentName={parentName}
            isChildClient={true}
            parentClientId={clientId}
          />
        ) : (
          isAuthorizedAddClientDetails && (
            <NoDataFoundCard
              text="Manage multiple entities related to your clients by adding a Child Client."
              icon={<EmptyTeamsAndUsersIcon />}
              subElement={
                <Box m={2}>
                  <GetAddChildEntitiesButton />
                </Box>
              }
            />
          )
        )}
      </Grid>
    </>
  );
};

export default ChildClientsTab;
